export default {
  campaignResults: null,
  campaignResultsLoaded: false,
};
